<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import GoAlert from "svelte-icons/go/GoAlert.svelte";
</script>

<strong class="alert">
    <div class="icon red"><GoAlert /></div>
    <slot />
</strong>
